module.exports = __webpack_public_path__ + "media/images/clickworker_com/app_download_qr_code-a008e0715ecdf21b416e8e66f349804f.png";